import React, { FC } from 'react'
import classNames from 'classnames'
import { FlexRow } from '@/atoms/FlexContainers'
import { CircleInfoIcon } from '@/atoms/Icons/CircleInfoIcon'
import { EyebrowXS, ParagraphSM, TitleXXS } from '@/atoms/Text'
import { NamedColor } from '@/constants/types'
import { useGuildRatingBySlug } from '@/services/GuildRatingService/GuildRatingService'
import { Translate, useTranslate } from '@/utils/translate/translate-client'
import { ParentsGuideTooltip } from '@/views/TicketCheckoutViews/ShowtimesView/components/ShowtimeDetailsPanel/ParentsGuide/ParentsGuideTooltip'

interface ParentsGuideProps {
  theatricalSlug: string
  className?: string
  popoverClassName?: string
  triggerOptions?: {
    iconClassName?: string
    textClassName?: string
    iconColor?: NamedColor
    textColor?: NamedColor
  }
}

export const ParentsGuide: FC<ParentsGuideProps> = ({
  theatricalSlug,
  className,
  popoverClassName,
  triggerOptions,
}) => {
  const { t } = useTranslate('tickets')
  const { rating } = useGuildRatingBySlug(theatricalSlug)

  if (!rating) return null

  const age = rating.ageText

  const trigger = (
    <FlexRow className={classNames('gap-1 items-center', className)}>
      <CircleInfoIcon
        color={triggerOptions?.iconColor ?? 'core-warning-600'}
        size={14}
        className={classNames('hidden md:block', triggerOptions?.iconClassName)}
      />
      <CircleInfoIcon
        color={triggerOptions?.iconColor ?? 'core-warning-600'}
        size={12}
        className={classNames('md:hidden', triggerOptions?.iconClassName)}
      />
      <EyebrowXS
        className={classNames('md:photon-eyebrow-sm underline', triggerOptions?.textClassName)}
        color={triggerOptions?.textColor ?? 'core-warning-600'}
        weight="semibold"
      >
        {t('parentsGuide', "Parent's Guide")}
      </EyebrowXS>
    </FlexRow>
  )
  const content = (
    <>
      <TitleXXS color="core-gray-950" weight="medium">
        <Translate i18nKey="guildRecommendedAgeTitle" t={t} values={{ age }}>
          <strong>{{ age }}</strong> (Guild Recommended Age)
        </Translate>
      </TitleXXS>
      <ParagraphSM className="mt-2 text-[0.688rem] leading-[16px]" color="core-gray-700">
        {rating.description}
      </ParagraphSM>
    </>
  )
  return <ParentsGuideTooltip trigger={trigger} content={content} className={popoverClassName} />
}
